import {TOption} from './TOption'

export const PAYMENT_TYPE: TOption[] = [
  {value: 'EP', label: 'Cash Partial'},
  {value: 'E', label: 'Cash Payment'},
  {value: 'DF', label: 'Distributor Financing'},
  {value: 'M', label: 'L/C at Sight'},
  {value: 'MB', label: 'UPAS L/C'},
  {value: 'MC', label: 'Usance L/C 30 days'},
  {value: 'P', label: 'Credit Payment'},
]
